import { render, staticRenderFns } from "./DashboardFeedbackByCategoryByWords.vue?vue&type=template&id=346bf397&"
import script from "./DashboardFeedbackByCategoryByWords.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedbackByCategoryByWords.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedbackByCategoryByWords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports